import { CDN_URL, catalogJsonUrl } from '../config.js';
import fetchCache from './fetchCache.js';
import { normalizeGenderForFilter } from './genderUtils.js';
import { filterOutfitsForSfw } from './nsfwTags.js';

let outfitsList = null;
let outfitsListLang = null;
let listPromise = null;
let listPromiseLang = null;

let outfitMappings = null;
let mappingsLang = null;

export const getOutfitMappings = () => outfitMappings;

export const applyOutfitNames = (characters, fallback = 'default outfit') => {
  const map = getOutfitMappings();
  characters.forEach((char) => {
    const outfitId = char.outfitId || 0;
    char.outfitName = map?.[outfitId]?.name || fallback;
  });
};

const unwrapOutfitsPayload = (data) => {
  if (Array.isArray(data)) return data;
  if (Array.isArray(data?.outfits)) return data.outfits;
  return null;
};

const buildOutfitIdMap = (allOutfits) => {
  const next = {};
  allOutfits.forEach((outfit) => {
    if (next[outfit.id]) return;
    next[outfit.id] = {
      name: outfit.name,
      gender: normalizeGenderForFilter(outfit.gender) || 'female',
    };
  });
  return next;
};

const loadUnfilteredOutfitsList = async (lang = 'en') => {
  if (outfitsList && outfitsListLang === lang) return outfitsList;
  if (listPromise && listPromiseLang === lang) {
    await listPromise;
    return outfitsList;
  }

  listPromiseLang = lang;
  listPromise = (async () => {
    const data = await fetchCache.fetchJSON(catalogJsonUrl(`data/outfits/outfits-${lang}.json`));
    const allOutfits = unwrapOutfitsPayload(data);
    if (!allOutfits) {
      throw new Error('Invalid outfit data received');
    }
    outfitsList = allOutfits;
    outfitsListLang = lang;
  })();

  try {
    await listPromise;
  } finally {
    listPromise = null;
    listPromiseLang = null;
  }
  return outfitsList;
};

export const loadOutfitsList = async (lang = 'en') => {
  const allOutfits = await loadUnfilteredOutfitsList(lang);
  return filterOutfitsForSfw(allOutfits);
};

export const loadOutfitMappings = async (lang = 'en') => {
  if (outfitMappings && mappingsLang === lang) return outfitMappings;

  try {
    const allOutfits = await loadUnfilteredOutfitsList(lang);
    outfitMappings = buildOutfitIdMap(allOutfits);
    mappingsLang = lang;
  } catch (error) {
    console.error('Failed to load outfits:', error);
    outfitMappings = { '29': { name: `Fallback ${lang}` } };
    mappingsLang = lang;
  }
  return outfitMappings;
};
